import { render, staticRenderFns } from "./SendIcon.vue?vue&type=template&id=1b7706b8&"
import script from "./SendIcon.vue?vue&type=script&lang=ts&"
export * from "./SendIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports